import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/style/common.scss'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import { formatNumber } from "@/utils/common";
Vue.prototype.$FormatNumber = formatNumber;

Vue.config.productionTip = false
import { GetUserInfo } from "@/api/Perfil";

new Vue({
  router,
  store,
  render: h => h(App),
  data() {
    return {
      hasHandledHomePopups: false
    }
  },
  created() {
    if (location.search) this.$store.commit('SETSEARCHPARAMS', location.search);
    this.setFontSize();
    setInterval(() => {
      if (this.$store.state.userInfo.token && this.$route.path !== '/Scratch') {
        GetUserInfo().then(res => {
          this.$store.commit('SETCASH', res);
          this.$store.commit('SETVIPINFO', res);
        });
      }
    }, 2000);
  },
  mounted() {
    window.addEventListener('resize', this.setFontSize);
  },
  methods: {
    async getHomePopupState() {
      if (!this.$store.state.userInfo.token || this.hasHandledHomePopups) return null;
      this.hasHandledHomePopups = true;
      const res = await GetUserInfo();
      if (res) {
        this.$store.commit('SETCASH', res);
        this.$store.commit('SETVIPINFO', res);
      }
      return {
        hourly: this.$store.state.userInfo.timePrize === true,
        registration: !this.$store.state.userInfo.cpf
      }
    },
    // 计算根元素 FontSize，设置 rem
    setFontSize () {
      document.documentElement.style.fontSize = `${document.documentElement.clientWidth / 24}px`;
    }
  },
}).$mount('#app')
